export enum PromoCodeIssuers {
  otostolik = 'otostolik',
  lesznoje = 'lesznoje',
  ostrowje = 'ostrowje',
  lubje = 'lubje',
  miedzioweje = 'miedzioweje',
  restaurant = 'restaurant',
}
